<app-statistik-igangvaerende-options
    (selectLedelseAnsvarlig)="onLedelseAnsvarligSelected($event)"
    (selectKundeAnsvarlig)="onKundeAnsvarligSelected($event)"
    (selectSagsAnsvarlig)="onSagsAnsvarligSelected($event)"
    (periodeChange)="onPeriodeChange($event)"
    (selectKoncern)="onKoncernSelected($event)"
    (export)="onExport()"
    [sagskortListe]="sagskortListe"
    [laCards]="laCards"
    [kaCards]="kaCards"
    [saCards]="saCards"
    [koncerns]="koncernList"
    [periode]="periode"
    [laID]="selectedLAId"
    [kaID]="selectedKAId"
    [saID]="selectedSAId"
></app-statistik-igangvaerende-options>
<div class="table__viewport">
    <table class="table table-hover table-striped table-sm table-frame__body">
        <thead class="fixed-top position-fixed  position-sticky">
            <tr>
                <th colspan="2">Kunde</th>
                <th>Navn</th>
                <th class="text-end">Realiseret på kunder</th>
                <th class="text-end">Faktureret på kunder </th>
                <th class="text-end">Igangværende arbejder</th>
                <th class="text-end">Forv. tab </th>
                <th class="text-end">Reguleringer</th>
                <th class="text-end">Netto</th>
                <th class="text-end">Sags Kort</th>
            </tr>
        </thead>

        <tbody>
            <ng-container *ngFor="let igangvaerende of igangvaerendeFilteredList; trackBy: trackIgangvaerendeGlkundenr">
                <tr class="item__tr">
                    <ng-container *ngIf="isStatistikIgangvaerendeVisiable(igangvaerende)">
                        <td class="link-td" (click)="OpenKundeModal(igangvaerende)"> {{ igangvaerende.glkundenr }}</td>
                        <td (click)="redirectToFakturering(igangvaerende.glkundenr)" class="link-td">F</td>
                        <td> {{ igangvaerende.navn }}</td>
                        <td class="text-end" (click)="openSagskortModal(igangvaerende.kid)" [ngClass]="{'link-td': (igangvaerende.realiseret + igangvaerende.realiseretKr != 0)}"> {{ igangvaerende.realiseret + igangvaerende.realiseretKr | currency:'DKK':'':'1.0-0':'da' }}</td>
                        <td class="text-end"> {{ igangvaerende.faktureret + igangvaerende.aconto | currency:'DKK':'':'1.0-0':'da' }}</td>
                        <td class="text-end"> {{ getIgangvaerende(igangvaerende) | currency:'DKK':'':'1.0-0':'da' }} </td>
                        <td class="text-end"> {{ igangvaerende.forventedTab | currency:'DKK':'':'1.0-0':'da' }}</td>
                        <td class="text-end"> {{ igangvaerende.regulering | currency:'DKK':'':'1.0-0':'da' }}</td>
                        <td class="text-end"> {{ getIgangvaerende(igangvaerende) - igangvaerende.forventedTab - igangvaerende.regulering | currency:'DKK':'':'1.0-0':'da'}} </td>
                        <td class="text-end">
                            <button
                                class="btn btn-primary btn-sm"
                                (click)="openSagskortModal(igangvaerende.kid)"
                                title="Åbn sagskort">
                                <i class="fas fa-folder-open"></i>
                            </button>
                        </td>
                    </ng-container>
                </tr>
            </ng-container>
        </tbody>

        <tfoot class="fixed-bottom position-fixed position-sticky">
            <tr *ngIf="this.igangvaerendeFilteredList">
                <th>Total</th>
                <th></th>
                <th></th>
                <th class="text-end">{{getRealiseretPaeKunderTotal() | currency:'DKK':'':'1.0-0':'da'}}</th>
                <th class="text-end">{{getFaktureretPaeKunderTotal() | currency:'DKK':'':'1.0-0':'da'}}</th>
                <th class="text-end">{{getIgangvaerendeArbejderTotal() | currency:'DKK':'':'1.0-0':'da'}}</th>
                <th class="text-end">{{getForventedTabTotal() | currency:'DKK':'':'1.0-0':'da'}}</th>
                <th class="text-end">{{getReguleringerTotal() | currency:'DKK':'':'1.0-0':'da'}}</th>
                <th class="text-end">{{getIgangvaerendeArbejderTotal() - getForventedTabTotal() - getReguleringerTotal() | currency:'DKK':'':'1.0-0':'da'}}</th>
                <th></th>
            </tr>
        </tfoot>

    </table>
</div>

